import modeType from '../../constants/ModeConstants';
import apiService from '../../services/ApiService';
import configuration from '../../constants/Configuration';
import apiServiceUtils from '../../components/utils/ApiServiceUtils';
import previewCommands from '../../components/utils/PreviewCommands';
import platformDetection from '../../components/utils/PlatformDetection';
import sessionUtils from '../../components/utils/SessionUtils';

const appParameters = {
    contentItemId: -1,
    contentRevisionId: -1,
    submitId: -1,
    clipartId: -1,
    exerciseId: -1,
    assignmentFolderId: -1,
    collaboration: false,
    isNewCartoonist: true, // true: load JSon/ false: load xml
    context: configuration.CONTEXT,
    locale: 'en_US',
    title: 'Cartoonist',
    defaultTitle: 'Cartoonist',
    navBarTitle: 'Cartoonist',
    newClipartId: -1,
    masterClipartId: configuration.MASTER_CLIPART_ID,
    thumbnailsUrl: undefined,
    assetsUrl: undefined,
    assignmentStatus: undefined,
    creatorUserId: -1,
    currentUserId: -1,
    isEmbedded: false,
    bundleVersion: '1.0.6',
    isMasterProduction: false, // should not be overrided,
    isMaster: false,
    isExercise: false,
    isIcsx: false,
    navBarDescription: 'Description',
    navBarThumbnailId: -1,
    iframeSrc: '',
    playerHref: '', // used to go back from FULLSCREEN mode to PORTFOLIO
    playerCurrentTime: -1,
    isFullscreen: false,
    token: '',
    urlSchemeId: -1,
    backToDashboardLink: undefined,
    downloadId: -1,
    isExportTab: false,
    videoClipartId: -1,
    s3key: undefined,
    stringId: undefined,
    isAudioToken: false,
    isAssignment: false,
    exerciseThumbnailUrl: undefined,
    exportId: -1,
    isExternVideo: false,
    masterAssignmentId: -1,
    currentTheme: '',
    currentMainUniverse: '',
    currentVideoTheme: '',
    isTest: false,

    getParameters() {
        const parameters = this.getJsonFromUrl();

        if (!parameters)
            return;

        if (parameters.isTest && parameters.isTest.length > 0)
            this.isTest = this.toBoolean(parameters.isTest);

        if (parameters.token && parameters.token.length > 0 && parameters.token != 'undefined')
            this.token = parameters.token;

        if (parameters.cartoonistVersion && parameters.cartoonistVersion.length > 0 && parameters.cartoonistVersion != 'undefined')
            this.bundleVersion = parameters.cartoonistVersion;

        if (parameters.masterAssignmentId && parameters.masterAssignmentId.length > 0 && parameters.masterAssignmentId != 'undefined')
            this.masterAssignmentId = parameters.masterAssignmentId;

        if (parameters.userId && parameters.userId.length > 0 && parameters.userId != 'undefined')
            this.currentUserId =  parseInt(parameters.userId);

        if (parameters.exportId && parameters.exportId.length > 0 && parameters.exportId != 'undefined')
            this.exportId =  parseInt(parameters.exportId);

        if (parameters.isExternVideo)
            this.isExternVideo = this.toBoolean(parameters.isExternVideo);

        if (parameters.locale && parameters.locale.length > 0 && parameters.locale != 'undefined') {
            if (parameters.locale.indexOf('fr_FR') != -1 || parameters.locale.indexOf('es_ES') != -1 || parameters.locale.indexOf('da_DK') != -1) {
                // for spanish, french, danish users we should load the english translations -- CH-671 and CART-1284
            } else {
                this.locale = parameters.locale;
            }

            if (this.locale === 'no_NO')
                this.locale = 'nb_NO';

            if (this.locale === 'no_NO_NY')
                this.locale = 'nn_NO';
        }

        if (parameters.context && parameters.context.length > 0 && parameters.context != 'undefined')
            this.context = parameters.context;

        if (parameters.isAudioToken)
            this.isAudioToken = this.toBoolean(parameters.isAudioToken);

        if (this.isAudioToken)
            this.context = modeType.AUDIO_TOOL;

        if (this.context == modeType.AUDIO_TOOL) {
            this.title = 'AudioEditor';
            this.defaultTitle = 'AudioEditor';
            this.navBarTitle = 'AudioEditor';
        }

        if (parameters.clipartId && parameters.clipartId.length > 0 && parameters.clipartId != 'undefined')
            this.clipartId = parseInt(parameters.clipartId);

        if (parameters.submitId && parameters.submitId.length > 0 && parameters.submitId != 'undefined')
            this.submitId =  parseInt(parameters.submitId);

        if (parameters.exerciseId && parameters.exerciseId.length > 0 && parameters.exerciseId != 'undefined')
            this.exerciseId =  parseInt(parameters.exerciseId);

        if (parameters.id && parameters.id.length > 0 && parameters.id != 'undefined')
            this.contentItemId = parseInt(parameters.id);

        if (parameters.isExercise && parameters.isExercise.length > 0)
            this.isExercise = this.toBoolean(parameters.isExercise);

        if (parameters.isMaster && parameters.isMaster.length > 0)
            this.isMaster = this.toBoolean(parameters.isMaster);

        if (parameters.assignmentStatus && parameters.assignmentStatus == 'INVITED' && parameters.title && parameters.title == 'CartoonistMasterSweden')
            this.isMaster = true;

        // When you click on an exercise, it can have contentItemId > 0 because it was created from another product.
        // An assignment link ... the only situation when submitId > 0 for a production which wasn't already saved

        if (configuration.IS_PROD() == true) {
            this.masterClipartId = configuration.MASTER_CLIPART_ID_PROD;

            if (this.isMaster || this.clipartId == this.masterClipartId || this.clipartId == 62315556 || this.contentItemId == 62344225) { // if is master clipart then as first universe load Ancient Greece
                // if (this.locale == 'sv_SE')
                //     this.clipartId = 70622606; // Sweden universe
                // else
                this.clipartId = configuration.DEFAULT_CLIPART_ID_PROD;

                this.isMasterProduction = true;

                // hack for CH-470 ... this new master universe production wasn't created properly
                if (this.contentItemId == 62344225)
                    this.contentItemId = -1;

                // A production with submit < 0 can have contentItemId > 0 (it's an exercise based on a production) ... but in this case it's the master so it should be empty
                if (this.submitId < 0)
                    this.contentItemId = -1
            }

            //TODO: Now, the only situation when the master clipart can be overrided is when for the master clipartId is changed and that master production is assigned with link to another user ... then that user can save the master with his own content
        } else {
            if (this.isMaster || this.clipartId == this.masterClipartId) { // if is master clipart then as first universe load Ancient Greece
                // if (this.locale == 'sv_SE')
                //     this.clipartId = 70622606; // Sweden universe
                // else
                this.clipartId = configuration.DEFAULT_CLIPART_ID;

                this.isMasterProduction = true;

                if (this.submitId < 0)
                    this.contentItemId = -1
            }
        }

        if (this.token.length > 0) {
            if (parameters.id && parameters.id.length > 0)
                this.urlSchemeId = parseInt(parameters.id);

            sessionUtils.doLogin(this.token, this.urlSchemeId);
            return;
        }

        if (this.context == modeType.DOWNLOAD) {
            if (parameters.backToDashboardLink && parameters.backToDashboardLink.length > 0)
                this.backToDashboardLink = parameters.backToDashboardLink;

            if (parameters.downloadId && parameters.downloadId.length > 0)
                this.downloadId = parseInt(parameters.downloadId);

            if (parameters.isExportTab && parameters.isExportTab.length > 0)
                this.isExportTab = true;

            return;
        }

        if (parameters.submitId == undefined && parameters.exerciseId == undefined)
            this.isIcsx = true;

        if (parameters.title && parameters.title.length > 0 && parameters.title.indexOf('CartoonistMaster') < 0 && parameters.title.indexOf('Cartoonist Master') < 0 && !this.isMaster)
            this.title = this.getCorrectTitle(parameters.title);

        if (parameters.contentRevisionId && parameters.contentRevisionId.length > 0)
            this.contentRevisionId = parseInt(parameters.contentRevisionId);

        if (parameters.assignmentStatus && parameters.assignmentStatus.length > 0 && parameters.assignmentStatus.length != 'undefined')
            this.assignmentStatus = parameters.assignmentStatus;

        if (parameters.embedded && parameters.embedded.length > 0)
            this.isEmbedded = this.toBoolean(parameters.embedded);

        if (parameters.isFullscreen && parameters.isFullscreen.length > 0)
            this.isFullscreen = this.toBoolean(parameters.isFullscreen);

        if (parameters.assignmentFolderId && parameters.assignmentFolderId.length > 0)
            this.assignmentFolderId =  parseInt(parameters.assignmentFolderId);

        if (parameters.collaboration && parameters.collaboration.length > 0)
            this.collaboration = parameters.collaboration;

        if (parameters.playerHref && parameters.playerHref.length > 0)
            this.playerHref = unescape(parameters.playerHref);

        if (parameters.playerCurrentTime && parameters.playerCurrentTime.length > 0)
            this.playerCurrentTime = parseFloat(parameters.playerCurrentTime);

        if (this.isPrintMode() == true)
            return;

        if (configuration.LOAD_LOCAL == false)
            this.getTitle();

        if (platformDetection.isIOS())
            previewCommands.isIOSFullScreen = this.isFullscreen;
    },
    getCorrectTitle(title) {
        if (title.indexOf('<br>') != -1)
            title = title.replace('<br>', '');

        return title;
    },
    toBoolean(value) {
        if (value == 'true' || value == true)
            return true;
        else
            return false;
    },
    getMode() {
        if (this.context == 'audioTool')
            return modeType.AUDIO_TOOL;

        if (this.context == 'audioToolPlayer')
            return modeType.AUDIO_TOOL_PLAYER;

        if (this.context == 'download')
            return modeType.DOWNLOAD;

        if (this.context == 'edit')
            return modeType.EDITOR;
        else
            return modeType.PLAYER;
    },
    isCartoonistPlayer() {
        if (this.context == modeType.PLAYER || this.context == 'player')
            return true;
        else
            return false;
    },
    isPrintMode() {
        if (this.context == 'print')
            return true;
        else
            return false;
    },
    getJsonFromUrl() {
        var arg = window.location.search;

        this.iframeSrc = window.location.href;
        var parameters = arg.substr(1);
        var result = {};

        parameters.split('&').forEach(function(part) {
            var item = part.split('=');
            result[item[0]] = decodeURIComponent(item[1]);
        });

        return result;
    },
    checkType(data) {
        if (data && (data.indexOf('<structureElement') != -1 || data.indexOf('<contentItemXML') != -1))
            this.isNewCartoonist = false;
    },
    getTitle() {
        if (this.context == 'edit' || this.context == modeType.AUDIO_TOOL) {
            apiServiceUtils.executeSafeApiCall(this.executeGetTitleCall.bind(this));
        }
    },
    executeGetTitleCall() {
        if (appParameters.submitId < 0) { // is exercise ... so get exercise title
            if (appParameters.exerciseId > 0) {
                apiService.getExercisesTitle(appParameters.exerciseId)
                    .then(response => {
                        return this.titleResponse(response);
                    });
            }
        } else {
            apiService.getSubmitTitle(appParameters.submitId)
                .then(response => {
                    return this.titleResponse(response);
                });
        }
    },
    titleResponse(response) {
        if (response) {
            if (response.assignment)
                this.isAssignment = true;

            if (response.title) { // get exercise title
                this.title = this.getCorrectTitle(response.title);
                this.navBarTitle = this.title;
                this.navBarDescription = response.description;
                this.navBarThumbnailId = response.thumbnailId;

                if (!this.isMaster)
                    this.exerciseThumbnailUrl = response.thumbnailURL;
            }
            else {
                if (response.assignment && response.assignment.title) { // get assignment title
                    if (this.title == this.defaultTitle || !this.isExercise)
                        this.title = this.getCorrectTitle(response.assignment.title);

                    this.navBarTitle = this.title;
                    this.navBarDescription = response.assignment.description;
                    this.navBarThumbnailId = response.assignment.thumbnail;
                }
                else
                if (response.content && response.content.title) { // get production title
                    if (this.title == this.defaultTitle)
                        this.title = this.getCorrectTitle(response.content.title);

                    this.navBarTitle = this.title;
                    this.navBarDescription = response.content.description;

                    if (response.content.thumbnail > 0)
                        this.navBarThumbnailId = response.content.thumbnail;
                    else
                        this.navBarThumbnailId = response.content.thumbnailId;

                    if (response.content.s3Key)
                        this.s3key = response.content.s3Key;
                }

                if (response.assignment && response.assignment.creator)
                    this.creatorUserId = response.assignment.creator.id;
            }
        }
    },
    setCloudfronUrls(thumbnailsUrl, assetsUrl) {
        if (this.thumbnailsUrl != undefined)
            return;

        this.thumbnailsUrl = `https://${thumbnailsUrl}/staticthumbs/svg/`;
        this.assetsUrl = `https://${assetsUrl}/`;
    },
    SVG_URL() {
        return 'https://creaza-cartoonist-svg.s3.eu-west-1.amazonaws.com/'; // load from s3 directly
    },
    THUMBNAIL_URL() {
        if (configuration.LOAD_LOCAL == true)
            return this.stageClipartBucket() + '/staticthumbs/svg/';
        else {
            if (this.thumbnailsUrl != undefined)
                return this.thumbnailsUrl;

            if (configuration.IS_PROD() == true)
                this.thumbnailsUrl = this.clipartBucket() + '/staticthumbs/svg/'; // creaza-clipart.s3.amazonaws.com
            else
                this.thumbnailsUrl = this.stageClipartBucket() + '/staticthumbs/svg/'; // creaza-clipart-test.s3.amazonaws.com

            return this.thumbnailsUrl;
        }
    },
    RESOURCES_LOCATION() {
        var bundleVersion = '1.0.2';

        if (this.bundleVersion)
            bundleVersion = this.bundleVersion;

        if (configuration.LOAD_LOCAL == true)
            return this.staticBucket() + '/releases/1.0.2/';
        else {
            if (configuration.IS_PROD() == true)
                return this.staticBucket() + '/releases/' + bundleVersion + '/';
            else
                return this.stageStaticBucket() + '/releases/' + bundleVersion + '/';
        }
    },
    getContentItemId() {
        if (this.contentRevisionId > 0)
            return this.contentRevisionId;
        else
            return this.contentItemId;
    },
    clipartBucket() {
        return 'https://clipart.creaza.com'; // CNAME
        // return 'https://d3b76ijxom7qfl.cloudfront.net'; // cloudfront
        // return 'https://creaza-clipart.s3.amazonaws.com'; // S3
    },
    svgBucket() {
        return 'https://svg-cartoonist.creaza.com/'; // CNAME
        // return 'https://d9e59cbjty4wx.cloudfront.net/'; // cloudfront
        // return 'https://creaza-cartoonist-svg.s3.amazonaws.com'; // S3
    },
    staticBucket() {
        return 'https://static-cartoonist.creaza.com'; // CNAME
        // return 'https://d2u42v3s6h8hv7.cloudfront.net'; // cloudfront
        // return 'https://creaza-static.s3.amazonaws.com/cartoonist'; // S3
    },
    stageStaticBucket() {
        return 'https://d2gmmubf5igsdk.cloudfront.net';
    },
    stageClipartBucket() {
        return 'https://d1a6w8sjwfrc1s.cloudfront.net';
    }
};

export default appParameters;



/** WEBPACK FOOTER **
 ** ./src/components/utils/AppParameters.js
 **/